import { SET_REDUX_STATE, SET_INITIAL_VALUE } from "../constants";

export const setReduxState = (payload: any) => ({
  type: SET_REDUX_STATE,
  payload,
});

export const setInitialValue = (payload: any) => ({
  type: SET_INITIAL_VALUE,
  payload,
});
